module.exports = __webpack_public_path__ + "static/robot@2x-4572e589bfef31196c182a3d2cdf8f52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/labs/robot@2x.jpg
// module id = 2656
// module chunks = 134932258599989